import React from "react";
import withRouter from "../../../../common/hooks/withRouter";
import {connect} from "react-redux";
import {Filter} from "../../../../common/components/Filter";
import {setKYBServicesFilter, updateKYBFilters} from "../../actions/ServicesActions";

export class KYBListSidebarFilters extends React.Component {

    handleDPFilter = (filterOption) => {
        this.props.setKYBServicesFilter(filterOption, "provider");
        this.props.updateKYBFilter();
    }

    handleStatusFilter = (filterOption) => {
        this.props.setKYBServicesFilter(filterOption, "status");
        this.props.updateKYBFilter();
    }

    handleSubDPTypeFilter = (filterOption) => {
        this.props.setKYBServicesFilter(filterOption, "sub_dp");
        this.props.updateKYBFilter();
    }

    handleVerifiableElementsFilter = (filterOption) => {
        this.props.setKYBServicesFilter(filterOption, "verifiable_elements");
        this.props.updateKYBFilter();
    }

    handleInvoiceNameFilter = (filterOption) => {
        this.props.setKYBServicesFilter(filterOption, "invoice_name");
        this.props.updateKYBFilter();
    }



    render() {

        return (
            <div className="sidebar-filter-container">
                <Filter
                    placeholder="Data Provider"
                    handleFilter={this.handleDPFilter}
                    options={this.props.kybFilterOptions.dpFilterOptions}
                    value={this.props.kybFilters.providerNameFilter}
                />
                <Filter
                    placeholder="Status"
                    handleFilter={this.handleStatusFilter}
                    options={this.props.kybFilterOptions.statusOptions}
                    value={this.props.kybFilters.statusFilter}
                />
                <Filter
                    placeholder="Sub DP Type"
                    handleFilter={this.handleSubDPTypeFilter}
                    options={this.props.kybFilterOptions.subDPTypeOptions}
                    value={this.props.kybFilters.subDPTypeFilter}
                />
                <Filter
                    placeholder="Matching Elements"
                    isMulti={true}
                    handleFilter={this.handleVerifiableElementsFilter}
                    options={this.props.kybFilterOptions.verifiableElementsOptions}
                    value={this.props.kybFilters.verifiableElementsFilter}
                />
                <Filter
                    placeholder="Invoice Name"
                    handleFilter={this.handleInvoiceNameFilter}
                    options={this.props.kybFilterOptions.invoiceNameOptions}
                    value={this.props.kybFilters.invoiceNameFilter}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    kyb_services: state.veritas.kybServices.kyb_services,
    kybFilterOptions: state.veritas.kybServices.kybFilterOptions,
    kybFilters: state.veritas.kybServices.kybFilters,
});

const mapDispatchToProps = dispatch => ({
    setKYBServicesFilter: (filterOption, type) => {dispatch(setKYBServicesFilter(filterOption, type))},
    updateKYBFilter: () => {dispatch(updateKYBFilters())},
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYBListSidebarFilters))
